export async function formCompletionSource(context) {
  const match = context.matchBefore(/\[#FORM\s+[\w-]*/)
  if (!match) return null
  if (match.from === match.to && !context.explicit) return null
  const prefix = "[#FORM "
  // match.text contains the full matched string
  const query = match.text.slice(prefix.length)

  try {
    const res = await fetch(`/api/v1/autocomplete/forms.json?query=${encodeURIComponent(query)}`, {
      headers: {
        "content-type": "application/json"
      }
    })
    const json = await res.json()


    return {
      from: match.from + prefix.length,
      options: json["forms"].map(img => ({
        label: img.alias,
        type: "form"
      }))
    }
  } catch(err) {
    if (err.name !== "AbortError") throw err
  }
}
